import FormatPrice from '@flatsy/core/Format/Price'
import { Body1, Body2, Header1, Header2, SubBody1 } from '@flatsy/core/MaterialUi/Typo'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import {
  bedroomsFormat,
  floorFormat,
  priceValue,
  roomsFormat,
  surfaceFormat,
} from '@flatsy/utils/Functions/format/Conversions'
import HotelOutlinedIcon from '@material-ui/icons/HotelOutlined'
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined'
import SquareFootIcon from '@material-ui/icons/SquareFoot'
import clsx from 'clsx'
import theme from '@flatsy/core/MuiTheme/theme'
import React from 'react'
import { Link } from '@material-ui/core'
import Line from '@flatsy/core/Layout/Line'
import { useMobile } from 'src/hooks/Mobile'
import * as ROUTES from 'src/constants/Routes'
import { generatePath, useHistory, useParams } from 'react-router'
import { useApplicationBooking } from 'src/hooks/ApplicationBooking'
import { parseApiDate } from '@flatsy/utils/Functions/DateTime/Date'
import { isPast } from 'date-fns'
import Instruction from '@flatsy/core/Content/Instruction'
import i18n from '@flatsy/utils/translations'
import { useStyles } from './Style'
import { InformationProps } from './Type'
import { renderCancelButton } from '../Mobile/Utils'

const Information: React.FC<InformationProps> = ({ asset }): React.ReactElement => {
  const classes = useStyles()
  const isMobile = useMobile()
  const history = useHistory()
  const { applicationId } = useParams<{ applicationId: string }>()
  const { booking } = useApplicationBooking({ applicationId })
  const handleCancel = async () => {
    history.push(
      generatePath(ROUTES.APPLICATION_DOSSIER_CANCEL, {
        applicationId,
      })
    )
  }

  const cancelButtonOrUndefined = () => {
    if (booking && isMobile && booking.start_date && booking.start_time) {
      const past = isPast(parseApiDate(`${booking?.start_date}T${booking?.start_time}`))
      if (!past) {
        return renderCancelButton(classes, handleCancel)
      }
    }
    return undefined
  }

  const renderRooms = () => {
    if (asset?.number_of_rooms || asset?.number_of_rooms === 0) {
      return (
        <div className={clsx(classes.assetInfo, classes.assetInfoPadding)}>
          <DashboardOutlinedIcon className={classes.iconGrey} />
          <Body1 fontColor={theme.palette.primary.dark}>{roomsFormat(asset.number_of_rooms)}</Body1>
        </div>
      )
    }
  }

  const renderBedrooms = () => {
    if (asset?.bedrooms || asset?.bedrooms === 0) {
      return (
        <div className={clsx(classes.assetInfo, classes.assetInfoPadding)}>
          <HotelOutlinedIcon className={classes.iconGreyBedroom} />
          <Body1 fontColor={theme.palette.primary.dark}>{bedroomsFormat(asset?.bedrooms)}</Body1>
        </div>
      )
    }
  }

  return (
    <>
      {isMobile && asset?.instructions && (
        <div className={classes.instructionMobile}>
          <Instruction asset={asset} />
        </div>
      )}
      <div className={classes.card}>
        <div className={classes.containerSidebar}>
          <div className={classes.sidebarInformation}>
            <Header1 className={classes.darkBlue} lowerCase>
              <>{asset && <FormatPrice price={priceValue(asset)} />}</>
              {!asset?.is_sale && <> {i18n.t('per_month')}</>}
            </Header1>
            {!asset?.is_sale && <SubBody1>{i18n.t('utilities_included')}</SubBody1>}
          </div>
          <div className={classes.address}>
            <Header2 className={classes.city}>{asset?.address_locality}</Header2>
            {asset?.ad_url && (
              <Link href={asset.ad_url} target="_blank">
                <Body2 className={classes.link}>{i18n.t('view_classified')}</Body2>
              </Link>
            )}
          </div>
        </div>
        <Line marginTopBottom="24px" />
        <div className={classes.containerAssetInfo}>
          {asset?.surface && (
            <div className={classes.assetInfo}>
              <SquareFootIcon className={classes.iconGrey} />
              <Body1 fontColor={theme.palette.primary.dark}>{surfaceFormat(asset.surface)}</Body1>
            </div>
          )}
          <div className={classes.assetInfo}>
            <img className={classes.iconGrey} src={FlatsyTheme.image.iconFloors} alt="icon-block" />
            <Body1 fontColor={theme.palette.primary.dark}>
              {floorFormat(asset?.floor || 0, true)}
            </Body1>
          </div>
          {renderRooms()}
          {renderBedrooms()}
        </div>
      </div>
      {cancelButtonOrUndefined()}
    </>
  )
}

export default Information
